const AdvertBox = ({ title, content, image }) => {
  return (
    <div className="ad-card">
      {image && <img src={image} alt={title} />}
      <div className="ad-card-body">
        <div className="ad-card-title">{title}</div>
        <div className="ad-card-text">{content}</div>
        <button className="follow-btn mt-2" style={{ fontSize: "12px", padding: "4px 12px" }}>
          Discover
        </button>
      </div>
    </div>
  );
};

export default AdvertBox;
